// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FrownOutlinedSvg from "@fishx/icons-svg/es/asn/FrownOutlined";
import FishxIcon from '../components/FishxIcon';

var FrownOutlined = function FrownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FrownOutlinedSvg
  }));
};

FrownOutlined.displayName = 'FrownOutlined';
export default React.forwardRef(FrownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FrownOutlined.js
// module id = 2838
// module chunks = 0